module.exports = new __parcel__URL__("Workation.66af47ba.webp").toString();